export interface LeafletSendRequest {
  model_id: string;
  email_address: string;
  article_code: string;
  name: string;
  remarks: string;
}

export class LeafletSendRequest implements LeafletSendRequest {}
